import React from 'react';

function ShareIcon({ width = 24, height = 24, className = "",color }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            viewBox="0 0 16.211 13.509"
        >
            <path
                id="Vector_-_2025-02-10T180652.869"
                data-name="Vector - 2025-02-10T180652.869"
                d="M16.211,6.3,9.907,0V3.6C3.6,4.5.9,9.006,0,13.509c2.252-3.152,5.4-4.593,9.907-4.593v3.692Z"
                fill="currentcolor"
            />
        </svg>
    );
}

export default ShareIcon;
